import React from "react";
import { Button } from "react-bootstrap";
import { AddIcon } from "../../icons/btnIcons";

const Btn = React.forwardRef(({
  variant = "primary",
  className = "",
  title = null,
  startIcon = null,
  endIcon = null,
  size = "base",
  isAddBtn = false,
  isLoading = false,
  children,
  areaTitle = null,
  ...rest
}, ref) => (
  <Button
    ref={ref}
    variant={variant}
    className={`flex-center gap-2 ${className}`}
    size={size}
    title={typeof areaTitle === "string" ? areaTitle : (typeof title === "string" ? title : undefined)}
    {...rest}
  >
    {isAddBtn && <i className="ratio-1 flex-center"><AddIcon /></i>}
    {startIcon && <i className="ratio-1 flex-center">{startIcon}</i>}
    {title && <span>{title}</span>}
    {children}
    {endIcon && <i className="ratio-1 flex-center">{endIcon}</i>}
  </Button>
));

export default Btn;
